export enum InputThemeColor {
  Light = 'light',
  Dark = 'dark',
}

export enum InputType {
  Text = 'text',
  Number = 'number',
  Password = 'password',
  Date = 'date',
}
